export const translate = (t, key, hasPrismaAccess) => {
  return t(`${key}${hasPrismaAccess ? '_prisma' : ''}`, { defaultValue: t(key) })
}
